module.exports = __webpack_public_path__ + "static/img/Clyde-Hotel.fd2c3a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Clyde-Hotel.jpg
// module id = f4Nm
// module chunks = 0